// TypingText.jsx
import React, { useEffect } from "react";
import { motion } from "framer-motion";

const TypingText = ({ text, speed, onComplete }) => {
  const characters = text.split("");

  useEffect(() => {
    const totalTime = characters.length * speed * 1000;
    const timeout = setTimeout(() => {
      onComplete?.();
    }, totalTime);

    return () => clearTimeout(timeout);
  }, [text, speed, onComplete, characters.length]);

  return (
    <p style={{ display: "inline-block" }}>
      {characters.map((char, index) => (
        <motion.span
          key={index}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: index * speed }}
        >
          {char}
        </motion.span>
      ))}
    </p>
  );
};

export default TypingText;
